import { render, staticRenderFns } from "./homepage.vue?vue&type=template&id=ad88df18&scoped=true"
import script from "./homepage.vue?vue&type=script&lang=js"
export * from "./homepage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad88df18",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Project\\certbuyliantuo\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ad88df18')) {
      api.createRecord('ad88df18', component.options)
    } else {
      api.reload('ad88df18', component.options)
    }
    module.hot.accept("./homepage.vue?vue&type=template&id=ad88df18&scoped=true", function () {
      api.rerender('ad88df18', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/home/homepage.vue"
export default component.exports